<template>
    <transition name="bbFade" @after-enter="showContent = true">
      <div class="modal" v-if="show" @click="showContent = false">
        <transition name="bbUp" @after-leave="$emit('close')">
          <div v-show="showContent" class="modal__card" @click.stop="">
            <div class="modal__dialog">
              <div class="modal__header">
  <!--             Back button  AMAGAT amb DISPLAY NONE via CSS -> en control de QA s'ha descartat aquesta funcionalitat-->
                <div class="modal__back" v-show="step > 1">
                  <img
                    @click="step--"
                    src="../../../assets/img/ico/ico-arrow-back.svg"
                    alt="Atras"
                  />
                </div>
                <div class="modal__title">
                  <slot name="titulo"></slot>
                </div>
                <div class="modal__close">
                  <img
                    src="../../../assets/img/ico/ico-close.svg"
                    alt="Cerrar"
                    @click="showContent = false"
                  />
                </div>
              </div>
              <div class="modal__content" ref="scroll_container">
                <div>
                  <section class="flux-fondos">
                    <div class="flux-fondos__header">
                      <small class="flux-fondos__step">
                        <span>{{ $t("guest.funds.stepNumerator", {step: step }) }}</span>
                      </small>
                      <h3 class="flux-fondos__title">
                        {{ steps[step] }}
                      </h3>
                    </div>
                    <div class="flux-fondos__content">
                      <div class="flux-fondos__left" :class="{ 'flux-fondos__left--hidden': step > 1 }">
                        <div class="flux-fondos__name" v-text="fund.title" />
                        <div class="ico-box ico-box--flex">
                          <img
                            :src="$fundIcons[fund.fundTypeId]"
                            alt="Tipo de fondo"
                          />
                        </div>
                      </div>
                      <div class="flux-fondos__right">
                        <FluxFondosClassicStep1
                          v-show="step === 1"
                          :fund="fund"
                          :list="list"
                          :key="fund.id"
                          @next="nextFirstStep"
                        ></FluxFondosClassicStep1>
                        <FluxFondosClassicStep2
                          v-show="step === 2"
                          :fund="fund"
                          :list="list"
                          :payment-method="paymentMethod"
                          @next="nextSecondStep"
                        ></FluxFondosClassicStep2>
                        <FluxFondosClassicStep3
                          v-show="step === 3"
                          :loading="loading"
                          :fund="fund"
                          :payment-method="paymentMethod"
                          :paymentName="paymentName"
                          :paymentData="paymentData"
                          @finish="finish"
                          :list="list"
                        ></FluxFondosClassicStep3>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </template>
  <script>
  import FluxFondosClassicStep1 from "../components/FluxFondosClassicStep1.vue";
  import FluxFondosClassicStep2 from "../components/FluxFondosClassicStep2.vue";
  import FluxFondosClassicStep3 from "../components/FluxFondosClassicStep3.vue";
  import CanBeClosedByEscKey from "../../../Mixins/CanBeClosedByEscKey";
  
  export default {
    name: "FluxFondosClassic",
    mixins: [CanBeClosedByEscKey],
    components: {
      FluxFondosClassicStep1,
      FluxFondosClassicStep2,
      FluxFondosClassicStep3,
    },
    props: {
      show: {
        type: Boolean,
        required: false,
      },
      fund: {
        type: Object,
        required: true,
      },
      list: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        loading: false,
        step: 1,
        paymentMethod: null,
        paymentName: null,
        paymentData: null,
        body: null,
        showContent: false,
        contribution: null,
        paymentSlug: null,
      };
    },
    computed: {
      steps() {
        return {
          1: this.$t("guest.funds.contributeToThisFund"),
          2: this.$t("guest.funds.completeData"),
          3: this.$t("guest.funds.actionInstruction", {x: this.$t("generic." + this.paymentSlug) }),
        };
      },
      bizumPhone() {
        // 2 BIZUM
        return this.fund.fundPaymentTypes.find(
          (paymentType) => paymentType.fundPaymentTypeId == 2
        ).info;
      },
    },
    methods: {
      close() {
        this.showContent = false;
        this.$emit("close");
      },
      nextFirstStep(paymentMethod) {
        this.paymentMethod = paymentMethod;
        this.step++;
        this.resetScroll()
      },
      resetScroll() {
        this.$refs.scroll_container.scrollTop = 0
      },
      nextSecondStep(body) {
        this.body = body;
        this.paymentName = body.paymentName;
        this.paymentData = body.paymentData;
        this.paymentSlug = body.paymentSlug;
        
        //create fund object
        this.contribution = {
          contributionMethodId: this.paymentMethod,
          amount: body.amount,
          net: body.amount,
          currency: 'eur',
          contributorName: body.name,
          contributorEmail: body.email,
        };
        
        this.step++;
        this.resetScroll()
      },
      async submitFund() {
        try {
          await this.$store.dispatch(
            'contributeToFund',
            {
              fund: this.fund, 
              contribution: this.contribution 
            });
        } catch (error) {
          console.log(error);
        }
      },
      async finish() {
        this.loading = true;
        try {
          await this.submitFund();
        } catch (error) {
          console.log(error);
        }
        this.loading = false;
        this.step = 1;
        this.$emit("finish");
      },
    },
  };
  </script>
  
  <style>
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  
  .fade-enter-active,
  .fade-leave-active {
    transition: 0.2s opacity ease-out;
  }
  </style>
  